export default "__VITE_ASSET__b39c87ca__"